/* eslint-disable sonarjs/no-duplicate-string */

export const advantages = [
  {
    title: 'Privacidade incorporada ao design',
    description:
      'Cuidamos do nível de solicitação dos dados aos usuários, evitando armazenar dados que não sejam necessários para a experiência da plataforma.',
    icon: 'fas fa-paint-brush',
  },
  {
    title: 'Segurança de ponta a ponta',
    description: 'Garantimos a proteção total do ciclo de vida do dado em nossa plataforma.',
    icon: 'fas fa-shield-alt',
  },
  {
    title: 'Respeito pela privacidade do usuário',
    description:
      'Temos total preocupação sobre a privacidade dos nossos usuários, principalmente das informações relacionadas ao contexto eduacional deles.',
    icon: 'fas fa-heart',
  },
  {
    title: 'Visibilidade e transparência',
    description:
      'Oferecemos total transparência a nossos stakeholders sobre a forma como os dados são tratados.',
    icon: 'fas fa-eye',
  },
];
